<template>
  <span :class="['badge', `text-bg-${variant}`, {'rounded-pill': pill}]"><slot></slot></span>
</template>
<script lang="ts" setup>
import {type BootstrapBadgeProps} from '@/components/shared/bootstrap/BootstrapBadge/BootstrapBadge.types';
const {variant = 'primary', pill = false} = defineProps<BootstrapBadgeProps>();
</script>
